import React, { useState, useContext, useEffect } from "react";
import DataTableComponent from "react-data-table-component";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Chip } from "@material-ui/core";
import Swal from "sweetalert2";

import Templete from "../../Templete/Templete";
import AuthService from "../../../../services/Admin/AuthService";
import ProductService from "../../../../services/Admin/ProductService";
import RechargeService from "../../../../services/Admin/RechargeService";
import PgService from "../../../../services/Admin/PgService";
import HttpError from "../../../../utill/HttpError";
import LoadingContext from "../../../../store/loading-context";

import TxnDetailsDialog from "../../Transactions/TxnDetailsDialog";

const RechargeReportSection = (props) => {
  const loadingCtx = useContext(LoadingContext);

  const [isLoading, setIsLoading] = useState(false);

  const [userType, setUserType] = useState();

  const [fromDate, setFromDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [toDate, setToDate] = useState(new Date().toISOString().slice(0, 10));
  const [status, setStatus] = useState();
  const [productId, setProductId] = useState();
  const [userId, setUserId] = useState();

  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState();
  const [count, setCount] = useState();
  const [data, setData] = useState();

  const [open, setOpen] = useState(false);
  const [selectedData, setSelectedData] = useState();

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.searchText]);

  const fetchData = async () => {
    const userType = await AuthService.getUserType();
    if (userType) {
      setUserType(userType);
    }

    setIsLoading(true);

    try {
      const token = AuthService.getAccessToken();

      const responseData = await RechargeService.report(
        token,
        fromDate,
        toDate,
        status,
        "",
        props.searchText,
        searchText,
        page,
        size,
        true
      );

      const status1 = responseData.status;
      const message = responseData.message;

      if (status1 === "SUCCESS") {
        setData(responseData.data.result);
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    setIsLoading(false);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const columns = [
    {
      name: "User ID",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span>{row.tbl_user.user_id}</span> <br />
          <small>{row.tbl_user.name}</small>
        </div>
      ),
    },

    {
      name: "Order ID",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span>{row.order_id}</span>
          <br />
          <small>{row.partner_order_id}</small>
        </div>
      ),
    },
    {
      name: "API Name",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span>{row.recharge_api ? row.recharge_api.name : "NULL"}</span>
        </div>
      ),
    },
    {
      name: "Operator",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span>Operator: {row.product.name}</span>
          <br />
          <span>Number: {row.optional1}</span>
          <br />
          <span>Amount: ₹{row.order_amount}</span>
        </div>
      ),
    },
    // {
    //   name: "Number",
    //   cell: (row) => (
    //     <div style={{ marginTop: "10px", marginBottom: "10px" }}>
    //       <span>{row.optional1}</span>
    //     </div>
    //   ),
    // },
    // {
    //   name: "Amount",
    //   cell: (row) => (
    //     <div style={{ marginTop: "10px", marginBottom: "10px" }}>
    //       <span>₹{row.order_amount}</span>
    //     </div>
    //   ),
    // },
    {
      name: "Status",
      cell: (row) => (
        <div>
          {(() => {
            if (row.status === "SUCCESS") {
              return (
                <h5>
                  <span class="badge badge-success">SUCCESS</span>
                </h5>
              );
            } else if (row.status === "FAILED") {
              return (
                <h5>
                  <span class="badge badge-danger">FAILED</span>
                </h5>
              );
            } else if (row.status === "PENDING") {
              return (
                <h5>
                  <span class="badge badge-warning">PENDING</span>
                </h5>
              );
            } else if (row.status === "REVERSAL") {
              return (
                <h5>
                  <span class="badge badge-danger">REVERSAL</span>
                </h5>
              );
            } else if (row.status === "REFUND") {
              return (
                <h5>
                  <span class="badge badge-danger">FAILED</span>
                </h5>
              );
            }
          })()}
        </div>
      ),
    },
    {
      name: "Commission",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span>User: ₹{row.commercial_amount}</span> <br />
          {userType === "Admin" && <span>Admin: ₹{row.admin_c_amount}</span>}
        </div>
      ),
    },
    {
      name: "Response",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          {(() => {
            if (row.status === "SUCCESS") {
              return (
                <span>
                  {row.secret_optional2 ? row.secret_optional2 : "NULL"}
                </span>
              );
            } else {
              return <span>N/A</span>;
            }
          })()}
        </div>
      ),
    },
    {
      name: "Operator Ref",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span> {row.operator_id ? row.operator_id : "NULL"}</span>
        </div>
      ),
    },
    {
      name: "Date Time",
      cell: (row) => (
        <div>
          <span>{row.created_on}</span>
        </div>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div class="btn-group btn-sm">
          <button type="button" class="btn btn-default btn-sm">
            Action
          </button>
          <button
            type="button"
            class="btn btn-default dropdown-toggle dropdown-icon"
            data-toggle="dropdown"
          >
            <span class="sr-only">Toggle Dropdown</span>
          </button>
          <div class="dropdown-menu" role="menu">
            <a
              class="dropdown-item"
              onClick={() => {
                apiStatusCheckHandler(row.id);
              }}
            >
              API Status Check
            </a>
            <a
              class="dropdown-item"
              onClick={() => {
                apiDisputeRequestHandler(row.id);
              }}
            >
              API Dispute Request
            </a>
          </div>
        </div>
      ),
    },
    {
      name: "More",
      cell: (row) => (
        <div>
          <button
            type="button"
            class="btn btn-primary btn-sm ml-1"
            onClick={() => {
              setSelectedData(row);
              setOpen(true);
            }}
          >
            <i class="fas fa-eye"></i>
          </button>
          <button
            type="button"
            class="btn btn-success btn-sm ml-1"
            onClick={async () => {
              const { value: formValues } = await Swal.fire({
                title: "Are you sure to update the status to SUCCESS?",
                html: `
                  <input id="swal-input1" placeholder="Operator ID" value=${row.operator_id} class="swal2-input">
                `,
                focusConfirm: false,
                showCancelButton: true,
                confirmButtonText: `Do Success`,
                confirmButtonColor: "green",
                preConfirm: () => {
                  return [document.getElementById("swal-input1").value];
                },
              });
              if (formValues) {
                updateTxnStatusHandler(row.id, "SUCCESS", formValues[0], null);
              }
            }}
          >
            <i class="fas fa-check"></i>
          </button>
          <button
            type="button"
            class="btn btn-danger btn-sm ml-1"
            onClick={async () => {
              const { value: formValues } = await Swal.fire({
                title: "Are you sure to update the status to FAILED?",
                html: `
                <input id="swal-input2" placeholder="Remark" class="swal2-input">
                `,
                focusConfirm: false,
                showCancelButton: true,
                confirmButtonText: `Do Failure`,
                confirmButtonColor: "red",
                preConfirm: () => {
                  return [document.getElementById("swal-input2").value];
                },
              });
              if (formValues) {
                updateTxnStatusHandler(row.id, "FAILED", null, formValues[0]);
              }
            }}
          >
            <i class="fas fa-times"></i>
          </button>
        </div>
        // <div>
        //   <IconButton
        //     color="primary"
        //     id="basic-button"
        //     aria-controls={open ? "basic-menu" : undefined}
        //     aria-haspopup="true"
        //     aria-expanded={open ? "true" : undefined}
        //     onClick={(event) => {
        //       handleClick(event);
        //       setSelectedData(row);
        //     }}
        //   >
        //     <MenuOpenIcon />
        //   </IconButton>

        //   <Menu
        //     id="basic-menu"
        //     anchorEl={anchorEl}
        //     open={openMenu}
        //     onClose={handleMenuClose}
        //     MenuListProps={{
        //       "aria-labelledby": "basic-button",
        //     }}
        //   >
        //     <MenuItem
        //       onClick={() => {
        //         apiDisputeRequestHandler(selectedData.id);
        //       }}
        //     >
        //       API Dispute Request
        //     </MenuItem>
        //     <MenuItem
        //       onClick={() => {
        //         apiStatusCheckHandler(selectedData.id);
        //       }}
        //     >
        //       API Status Check
        //     </MenuItem>
        //   </Menu>

        //   <IconButton
        //     color="primary"
        //     aria-label="upload picture"
        //     component="span"
        //     onClick={() => {
        //       setSelectedData(row);
        //       setOpen(true);
        //     }}
        //   >
        //     <MenuIcon />
        //   </IconButton>

        //   <IconButton
        //     color="success"
        //     aria-label="upload picture"
        //     component="span"
        //     onClick={async () => {
        //       const { value: formValues } = await Swal.fire({
        //         title: "Are you sure to update the status to SUCCESS?",
        //         html: `
        //           <input id="swal-input1" placeholder="Operator ID" value=${row.operator_id} class="swal2-input">
        //         `,
        //         focusConfirm: false,
        //         showCancelButton: true,
        //         confirmButtonText: `Do Success`,
        //         confirmButtonColor: "green",
        //         preConfirm: () => {
        //           return [document.getElementById("swal-input1").value];
        //         },
        //       });
        //       if (formValues) {
        //         updateTxnStatusHandler(row.id, "SUCCESS", formValues[0], null);
        //       }
        //     }}
        //   >
        //     <DoneOutlineIcon />
        //   </IconButton>

        //   <IconButton
        //     color="error"
        //     aria-label="upload picture"
        //     component="span"
        //     onClick={async () => {
        //       const { value: formValues } = await Swal.fire({
        //         title: "Are you sure to update the status to FAILED?",
        //         html: `
        //         <input id="swal-input2" placeholder="Remark" class="swal2-input">
        //         `,
        //         focusConfirm: false,
        //         showCancelButton: true,
        //         confirmButtonText: `Do Failure`,
        //         confirmButtonColor: "red",
        //         preConfirm: () => {
        //           return [document.getElementById("swal-input2").value];
        //         },
        //       });
        //       if (formValues) {
        //         updateTxnStatusHandler(row.id, "FAILED", null, formValues[0]);
        //       }
        //     }}
        //   >
        //     <CloseIcon />
        //   </IconButton>
        // </div>
      ),
    },
  ];

  const updateTxnStatusHandler = async (id, status, operator_id, remark) => {
    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await RechargeService.updateTxnStatus(
        token,
        id,
        status,
        operator_id,
        remark
      );

      const status1 = responseData.status;
      const message = responseData.message;

      if (status1 === "SUCCESS") {
        Swal.fire("Success!", message, "success");
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }

    loadingCtx.stopLoading();
  };

  const apiDisputeRequestHandler = async (id) => {
    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await RechargeService.apiDisputeRequest(token, id);

      const status1 = responseData.status;
      const message = responseData.message;
      const log = responseData.data ? responseData.data.log : null;

      //  alert(message);
      Swal.fire({
        title: message,
        text: log ? JSON.stringify(log) : "null",
      });
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }

    loadingCtx.stopLoading();
  };

  const apiStatusCheckHandler = async (id) => {
    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await RechargeService.apiStatusCheck(token, id);

      const status1 = responseData.status;
      const message = responseData.message;
      const log = responseData.data ? responseData.data.log : null;

      Swal.fire({
        title: message,
        text: log ? JSON.stringify(log) : "null",
      });
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }

    loadingCtx.stopLoading();
  };

  return (
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-header">
                <h3 class="card-title">Recharge Report</h3>
              </div>

              <div class="card-body">
                <div class="row mt-2">
                  <div class="col-md-12 mx-auto">
                    <form autoComplete="off">
                      <div class="row">
                        <div class="col-sm-3">
                          <div class="form-group">
                            <input
                              type="date"
                              class="form-control"
                              placeholder="From Date"
                              onChange={(e) => {
                                setFromDate(e.target.value);
                              }}
                              defaultValue={fromDate}
                            />
                          </div>
                        </div>

                        <div class="col-sm-3">
                          <div class="form-group">
                            <input
                              type="date"
                              class="form-control"
                              placeholder="To Date"
                              onChange={(e) => {
                                setToDate(e.target.value);
                              }}
                              defaultValue={toDate}
                            />
                          </div>
                        </div>

                        <div class="col-sm-3">
                          <div class="form-group">
                            <select
                              className="form-control"
                              onChange={(e) => {
                                setStatus(e.target.value);
                              }}
                            >
                              <option value={status ? status : ""}>
                                {status ? status : "Select Status"}{" "}
                              </option>
                              <option value="SUCCESS">SUCCESS</option>
                              <option value="PENDING">PENDING</option>
                              <option value="REFUND">FAILED</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-sm-3">
                          <div class="form-group">
                            <select
                              className="form-control"
                              onChange={(e) => {
                                setProductId(e.target.value);
                              }}
                            >
                              <option value="">Select Operator</option>
                              <option value="1">Airtel</option>
                              <option value="2">BSNL Topup</option>
                              <option value="3">BSNL Special</option>
                              <option value="4">JIO</option>
                              <option value="5">Vi</option>
                              <option value="6">Airtel Digital TV</option>
                              <option value="7">Dish TV</option>
                              <option value="8">Sun Direct</option>
                              <option value="9">Tata Sky</option>
                              <option value="10">Videocon D2H</option>
                              <option value="47">Google Play</option>
                              <option value="15">Electricity</option>
                              <option value="16">Fastag</option>
                              <option value="27">Piped Gas</option>
                              <option value="28">Mobile Postpaid</option>
                              <option value="29">Landline Postpaid</option>
                              <option value="30">Water</option>
                              <option value="31">DTH</option>
                              <option value="32">Broadband Postpaid</option>
                              <option value="33">Clubs and Associations</option>
                              <option value="34">Hospital and Pathology</option>
                              <option value="35">Credit Card</option>
                              <option value="36">LPG Gas</option>
                              <option value="37">Loan Repayment</option>
                              <option value="38">Life Insurance</option>
                              <option value="39">Health Insurance</option>
                              <option value="40">Cable TV</option>
                              <option value="41">Education Fees</option>
                              <option value="42">Housing Society</option>
                              <option value="43">Municipal Taxes</option>
                              <option value="44">Municipal Services</option>
                              <option value="45">Subscription</option>
                              <option value="46">Insurance</option>
                            </select>
                          </div>
                        </div>

                        {/* <div class="col-sm-3">
                              <div class="form-group">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="User ID"
                                  defaultValue={userId}
                                  onChange={(e) => {
                                    setUserId(e.target.value);
                                  }}
                                />
                              </div>
                            </div> */}

                        <div class="col-sm-3">
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Search Text"
                              onChange={(e) => {
                                setSearchText(e.target.value);
                              }}
                            />
                          </div>
                        </div>

                        <div class="col-sm-6" style={{ textAlign: "center" }}>
                          <div class="d-grid gap-2 d-md-flex">
                            <button
                              type="button"
                              class="btn btn-primary mr-4"
                              onClick={() => {
                                fetchData();
                              }}
                            >
                              <i class="fa fa-search"></i> Search
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                <DataTableComponent
                  noHeader={true}
                  columns={columns}
                  data={data}
                  progressPending={isLoading}
                  highlightOnHover
                  pagination
                  paginationServer
                  paginationTotalRows={count}
                  paginationPerPage={size}
                  onChangePage={(page) => {
                    setPage(page);
                    fetchData();
                  }}
                  paginationRowsPerPageOptions={[
                    10, 20, 50, 100, 200, 500, 1000,
                  ]}
                  onChangeRowsPerPage={(size) => {
                    setSize(size);
                    fetchData();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <TxnDetailsDialog setOpen={setOpen} open={open} fData={selectedData} />
    </section>
  );
};

export default RechargeReportSection;
